module.exports = __webpack_public_path__ + "static/helloworld-f9ee6fa10eef262efe36e19f1ccc1113.jpg";